import { i18, trb } from '../../Utilities';
import { Amount } from '../Amount';

interface IProps {
  data: {
    Quantity: number;
    Amount: number;
    Currency: string;
    PaymentSystem: string;
    Commission: number;
    CommissionCurrency: string;
  }[];
}

export const ReportUnsignedPaymentFiles = ({ data }: IProps) => {
  return (
    <div>
      <h3 className="eb_content_subtitle">{trb(i18.Labels.PaymentsReport)}</h3>
      <div className="eb_table mb-3 w-100 eb_table_wrapper_bottom_lined">
        <div className="row eb_table_head d-none d-lg-flex">
          <div className="col-md-3">{trb(i18.PaymentBulkReport.Type)}</div>
          <div className="col-md-3">{trb(i18.PaymentBulkReport.Quantity)}</div>
          <div className="col-md-3 text-right">{trb(i18.PaymentBulkReport.Amount)}</div>
          <div className="col-md-3 text-right">{trb(i18.PaymentBulkReport.Commission)}</div>
        </div>
        {data?.map((item, index) => (
          <div
            className="row eb_table_row"
            key={index}
          >
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="d-block d-lg-none text-black-50">{trb(i18.PaymentBulkReport.Type)}</div>
              <div className="eb_fw_600">{trb(`PaymentSystem.${item.PaymentSystem}`)}</div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="d-block d-lg-none text-black-50">{trb(i18.PaymentBulkReport.Quantity)}</div>
              {item.Quantity}
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-lg-right">
              <div className="d-block d-lg-none text-black-50">{trb(i18.PaymentBulkReport.Amount)}</div>
              <Amount
                value={item.Amount}
                suffix={item.Currency}
                typography={undefined}
              />
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-lg-right">
              <div className="d-block d-lg-none text-black-50">{trb(i18.PaymentBulkReport.Commission)}</div>
              <Amount
                value={item.Commission}
                suffix={item.CommissionCurrency}
                typography={undefined}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
